// extracted by mini-css-extract-plugin
export default {"clientsButton":"ClientsPageClientsList_clientsButton__XPdVg","logo":"ClientsPageClientsList_logo__4rwc-"};